import React, { useState, useContext, useEffect, memo } from "react";
import { makeStyles } from "@mui/styles";
import {
  Modal,
  Box,
  Button,
  TextField,
  FormControl,
  Divider,
  Typography,
  IconButton,
  InputLabel,
  Select,
  Input,
  MenuItem,
  useTheme,
  Chip,
  Autocomplete,
} from "@mui/material";

import Draggable from "react-draggable";

import { Cancel, AddCircle, Delete } from "@mui/icons-material";
// eslint-disable-next-line

import AlertaContext from "../../../Context/Alerta/AlertaContext";

import MenuContext from "../../../Context/Menu/MenuContext";
import * as iconosImport from "@mui/icons-material";
import { trimPropsItem } from "../../../config/const";
import AuthContext from "../../../Context/Auth/AuthContext";

function getModalStyle() {
  return {
    borderRadius: "15px",
    position: "absolute",

    overflow: "scroll",
    maxHeight: "80vh",
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",

    width: "60%",
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    marginTop: "8vh",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      marginTop: "2vh",
    },
  },
  formD: {
    flexGrow: 1,
    margin: theme.spacing(0.5),
    width: "45%",
    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
      width: "45%",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      margin: "2px",
      width: "95%",
    },
  },
  form33: {
    flexGrow: 1,
    margin: theme.spacing(0.5),
    width: "32%",
    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
      width: "45%",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      margin: "2px",
      width: "95%",
    },
  },
  formAllW: {
    flexGrow: 1,
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    width: "95%",
    [theme.breakpoints.down("md")]: { padding: "0", margin: "2px" },
    [theme.breakpoints.down("sm")]: { padding: "0", margin: "2px" },
  },
  ocultar: {
    display: "none",
  },
}));

const ModalAsignatura = (props) => {
  const {
    categoriaActiva,
    changeCategoriaActiva, // eslint-disable-next-line
    editarCategoria,
    rows,
  } = useContext(MenuContext);

  // eslint-disable-next-line
  const { mostrarAlerta } = useContext(AlertaContext);
  const { usuario } = useContext(AuthContext);
  //props
  const { open, setopen } = props;
  const [seccion, setseccion] = useState({
    principalSeccion: true,
    tutorialesSeccion: false,
    inicioSeccion: false,
  });
  const { principalSeccion, inicioSeccion, tutorialesSeccion } = seccion;
  const [categoria, setcategoria] = useState(categoriaActiva);
  const { name, icon, orden, path, categoriaEmpresa, tutoriales } =
    categoria.sidInfo;

  useEffect(() => {
    setcategoria(categoriaActiva);
  }, [categoriaActiva]);

  const defaultActive = () => {
    changeCategoriaActiva({
      sidId: 0,
      sidInfo: {
        orden: 1,
        path: "",
        name: "",
        icon: "",
        component: "",
        layout: "",
        tipo: "",
        ruta: false,
        expandible: true,
        permisos: ["USUARIO"],
        agregar: ["USUARIO"],
        editar: ["USUARIO"],
        ver: ["USUARIO"],
        eliminar: ["USUARIO"],
        impExp: ["USUARIO"],
        categoriaEmpresa: [],
        tutoriales: [],
      },
    });
    setopen(false);
  };

  const handleChange = (e) => {
    setcategoria({
      ...categoria,
      sidInfo: {
        ...categoria.sidInfo,
        [e.target.name]: e.target.value,
      },
    });
  };

  //hook de estilos
  const clases = useStyles();
  //definiendo los estilos del modal
  const [modalStyle] = useState(getModalStyle);
  // const handleEditar = async () => {
  //   // if (validarEmail(emaildepaypal)) {
  //   //   return mostrarAlerta("Email paypal no es valido ", "error");
  //   // }
  //   if (password !== "") {
  //
  //   } else {
  //
  //   }

  //   setopen(false);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  function getStylesEspecialidades(name, permisos, theme) {
    return {
      fontWeight:
        permisos.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
       backgroundColor: permisos.indexOf(name) === -1 ? "white" : theme.palette.primary.main,
    };
  }

  const theme = useTheme();

  const [iconos, seticonos] = useState(null);
  useEffect(() => {
    seticonos(Object.keys(iconosImport));
  }, []);

  const handleEditar = () => {
    editarCategoria({
      ...categoria,
      sidInfo: { ...trimPropsItem(categoria.sidInfo) },
    });
    defaultActive();
  };
  const tienePermiso = (component) => {
    if (!usuario.permisos_usuario[usuario.rucempresa]) {
      const res = component.sidInfo.permisos.some((itemPermiso) => {
        return usuario.rol.some(
          (itemRolUsuario) => itemRolUsuario === itemPermiso
        );
      });

      return res;
    }
    if (
      !usuario.permisos_usuario[usuario.rucempresa][component.sidInfo.component]
    ) {
      const res = component.sidInfo.permisos.some((itemPermiso) => {
        return usuario.rol.some(
          (itemRolUsuario) => itemRolUsuario === itemPermiso
        );
      });

      return res;
    }
    if (
      usuario.permisos_usuario[usuario.rucempresa][component.sidInfo.component]
        .permisos === 0
    ) {
      const res = component.sidInfo.permisos.some((itemPermiso) => {
        return usuario.rol.some(
          (itemRolUsuario) => itemRolUsuario === itemPermiso
        );
      });

      return res;
    }
    if (
      usuario.permisos_usuario[usuario.rucempresa][component.sidInfo.component]
        .permisos === 1
    ) {
      return true;
    }
    if (
      usuario.permisos_usuario[usuario.rucempresa][component.sidInfo.component]
        .permisos === 2
    ) {
      return false;
    }
  };
  const permisos = (item) => {
    return item.sidInfo.categoriaEmpresa.some(
      (itemCatEmp) => itemCatEmp === usuario.empCategoria
    );
  };
  const bloquearFuncion = (item) => {
    if (item.sidInfo.bloquearAreaDepartamento === "SI") {
      const bloquear = item.sidInfo.areasDepartamento.some(
        (itemArea) => itemArea === usuario.areadepartamento
      );

      if (bloquear) {
        return false;
      } else {
        return true;
      }
    }
  };
  if (!iconos) {
    return null;
  }

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Draggable handle="#handle">
          <Box display="flex" justifyContent="center">
            <div style={modalStyle} className={clases.paper}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
                style={{ cursor: "-webkit-grab" }}
              >
                <Typography
                  id="handle"
                  variant="button"
                  color="initial"
                  align="center"
                >
                  Editar categoria.
                </Typography>
                <Box display="flex" alignItems="center">
                  <IconButton
                    aria-label=""
                    style={{ margin: "0px" }}
                    onClick={() => {
                      defaultActive();
                    }}
                  >
                    <Cancel color="secondary" />
                  </IconButton>
                </Box>
              </Box>

              <Divider />

              <Divider />
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems=" stretch"
                width="100%"
              >
                <Box>
                  <Button
                    variant={principalSeccion ? "contained" : "text"}
                    disableElevation
                    style={{ padding: "8px" }}
                    color={"secondary"}
                    onClick={() => setseccion({ principalSeccion: true })}
                  >
                    Principal
                  </Button>{" "}
                  <Button
                    variant={inicioSeccion ? "contained" : "text"}
                    disableElevation
                    style={{ padding: "8px" }}
                    color={"secondary"}
                    onClick={() => setseccion({ inicioSeccion: true })}
                  >
                    Inicio
                  </Button>
                  <Button
                    variant={tutorialesSeccion ? "contained" : "text"}
                    disableElevation
                    style={{ padding: "8px" }}
                    color={"secondary"}
                    onClick={() => setseccion({ tutorialesSeccion: true })}
                  >
                    Tutoriales
                  </Button>
                </Box>
                {/* <FormControlLabel
                control={
                  <Switch
                    checked={perEstado === "ACTIVO" ? true : false}
                    onChange={(e) => {
                      setitem({
                        ...item,
                        perEstado: e.target.checked ? "ACTIVO" : "INACTIVO",
                      });
                    }}
                    name="antoine"
                  />
                }
                label="Estado"
              /> */}
              </Box>
              <Divider />
              <Box
                display="flex"
                flexWrap="wrap"
                alignItems="flex-end"
                borderRadius="0px 50px 50px 0px"
                mb={2}
                p={1}
              >
                {principalSeccion ? (
                  <>
                    <>
                      <TextField
                        onChange={(e) => {
                          if (e.target.value === "categoria") {
                            setcategoria({
                              ...categoria,
                              sidInfo: {
                                ...categoria.sidInfo,
                                [e.target.name]: e.target.value,
                              },
                            });
                          }
                          if (e.target.value === "subCategoria") {
                            setcategoria({
                              ...categoria,
                              sidInfo: {
                                ...categoria.sidInfo,
                                categoria: "",
                                [e.target.name]: e.target.value,
                              },
                            });
                          }
                          if (e.target.value === "subsubCategoria") {
                            setcategoria({
                              ...categoria,
                              sidInfo: {
                                ...categoria.sidInfo,
                                subcategoria: "",
                                [e.target.name]: e.target.value,
                              },
                            });
                          }
                        }}
                        className={clases.formD}
                        name="tipo"
                        label="Tipo"
                        value={categoria.sidInfo.tipo}
                        required
                        fullWidth
                        select
                        InputLabelProps={{ shrink: true }}
                        SelectProps={{ displayEmpty: true }}
                      >
                        {["categoria", "subCategoria", "subsubCategoria"].map(
                          (item, index) => {
                            return (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            );
                          }
                        )}
                      </TextField>

                      {categoria.sidInfo.tipo === "subCategoria" ? (
                        <TextField
                          onChange={(e) => {
                            setcategoria({
                              ...categoria,
                              sidInfo: {
                                ...categoria.sidInfo,
                                [e.target.name]: e.target.value,
                              },
                            });
                          }}
                          className={clases.formD}
                          name="categoria"
                          label="Categoria"
                          value={categoria.sidInfo.categoria}
                          fullWidth
                          select
                          InputLabelProps={{ shrink: true }}
                        >
                          {rows
                            .filter(
                              (route) =>
                                (route.sidInfo.tipo === "categoria" ||
                                  !route.sidInfo.tipo) &&
                                route.sidInfo.path !== categoria.sidInfo.path &&
                                route.sidInfo.expandible
                            )
                            .map((prop, key) => {
                              if (!tienePermiso(prop)) {
                                return null;
                              }
                              if (!permisos(prop)) {
                                return null;
                              }
                              if (bloquearFuncion(prop)) {
                                return null;
                              }

                              return (
                                <MenuItem key={key} value={prop.sidInfo.path}>
                                  {prop.sidInfo.path}
                                </MenuItem>
                              );
                            })}
                        </TextField>
                      ) : null}
                      {categoria.sidInfo.tipo === "subsubCategoria" ? (
                        <TextField
                          onChange={(e) => {
                            setcategoria({
                              ...categoria,
                              sidInfo: {
                                ...categoria.sidInfo,
                                [e.target.name]: e.target.value,
                              },
                            });
                          }}
                          className={clases.formD}
                          name="subcategoria"
                          label="Sub Categoria"
                          value={categoria.sidInfo.subcategoria}
                          fullWidth
                          select
                          InputLabelProps={{ shrink: true }}
                        >
                          {rows
                            .filter(
                              (route) =>
                                (route.sidInfo.tipo === "subCategoria" ||
                                  !route.sidInfo.tipo) &&
                                route.sidInfo.path !== categoria.sidInfo.path &&
                                route.sidInfo.expandible
                            )
                            .map((prop, key) => {
                              if (!tienePermiso(prop)) {
                                return null;
                              }
                              if (!permisos(prop)) {
                                return null;
                              }
                              if (bloquearFuncion(prop)) {
                                return null;
                              }
                              return (
                                <MenuItem key={key} value={prop.sidInfo.path}>
                                  {prop.sidInfo.path}
                                </MenuItem>
                              );
                            })}
                        </TextField>
                      ) : null}
                    </>
                    <TextField
                      onChange={handleChange}
                      className={clases.formD}
                      name="name"
                      label="Nombre"
                      value={name}
                      required
                      fullWidth
                    />
                    {/* <FormControl className={clases.formD}>
                  <InputLabel id="demo-mutiple-chip-label">Permisos</InputLabel>
                  <Select
                    labelId="demo-mutiple-chip-label"
                    id="demo-mutiple-chip"
                    multiple
                    name="permisos"
                    value={permisos}
                    onChange={handleChange}
                    input={<Input id="select-multiple-chip" />}
                    MenuProps={MenuProps}
                    renderValue={(selected) => (
                      <div className={clases.chips}>
                        {selected.map((value) => {
                          return (
                            <>
                              <Chip
                                key={value}
                                label={value}
                                className={clases.chip}
                              />
                            </>
                          );
                        })}
                      </div>
                    )}
                  >
                    {[
                      "CLIENTE",
                      "PROVEEDOR",
                      "ADMINISTRACION",
                      "USUARIO",
                      "VENDEDOR",
                      "TECNICO",
                      "ADMIN",
                    ].map((row) => (
                      <MenuItem
                        key={row}
                        value={row}
                        style={getStylesEspecialidades(row, permisos, theme)}
                      >
                        {row}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}
                    <FormControl className={clases.formD}>
                      <InputLabel id="demo-mutiple-chip-label">
                        Categoria Empresa
                      </InputLabel>
                      <Select
                        labelId="demo-mutiple-chip-label"
                        id="demo-mutiple-chip"
                        multiple
                        name="categoriaEmpresa"
                        value={categoriaEmpresa}
                        onChange={handleChange}
                        input={<Input id="select-multiple-chip" />}
                        MenuProps={MenuProps}
                        renderValue={(selected) => (
                          <div className={clases.chips}>
                            {selected.map((value) => {
                              return (
                                <Chip
                                  key={value}
                                  label={value}
                                  className={clases.chip}
                                />
                              );
                            })}
                          </div>
                        )}
                      >
                        {["CONTABLE", "ISP", "GASOLINERA", "VETERINARIA"].map(
                          (row) => (
                            <MenuItem
                              key={row}
                              value={row}
                              style={getStylesEspecialidades(
                                row,
                                categoriaEmpresa,
                                theme
                              )}
                            >
                              {row}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                    <FormControl className={clases.formD} fullWidth>
                      <Autocomplete
                        options={iconos.map((node) => node)}
                        getOptionLabel={(option) => option}
                        id="controlled-demo"
                        value={icon}
                        name="a"
                        onChange={(event, newValue) => {
                          setcategoria({
                            ...categoria,
                            sidInfo: { ...categoria.sidInfo, icon: newValue },
                          });
                        }}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            label={
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                {/* Icono Derecha <Icon> {hacerIcono(icon)}</Icon> */}
                              </Box>
                            }
                            fullWidth
                            name="a"
                            variant="standard"
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    </FormControl>
                    <TextField
                      onChange={(e) => {
                        setcategoria({
                          ...categoria,
                          sidInfo: {
                            ...categoria.sidInfo,
                            [e.target.name]: e.target.value,
                          },
                        });
                      }}
                      className={clases.formD}
                      type="number"
                      name="orden"
                      label="Orden"
                      value={orden}
                      required
                      fullWidth
                    />
                    {categoria.sidInfo.tipo === "categoria" ? null : (
                      <TextField
                        onChange={(e) => {
                          setcategoria({
                            ...categoria,
                            sidInfo: {
                              ...categoria.sidInfo,
                              [e.target.name]: e.target.value,
                            },
                          });
                        }}
                        className={clases.formD}
                        name="categoria"
                        label="Categoria"
                        value={categoria.sidInfo.categoria}
                        required
                        fullWidth
                        select
                        InputLabelProps={{ shrink: true }}
                        SelectProps={{ displayEmpty: true }}
                      >
                        <MenuItem value="">Seleccione</MenuItem>
                        {rows.map((item) => {
                          if (item.sidInfo.tipo === "categoria") {
                            return (
                              <MenuItem value={item.sidInfo.path}>
                                {item.sidInfo.path}
                              </MenuItem>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </TextField>
                    )}
                    <TextField
                      onChange={(e) => {
                        setcategoria({
                          ...categoria,
                          sidInfo: {
                            ...categoria.sidInfo,
                            [e.target.name]:
                              e.target.value.length < 2
                                ? categoria.sidInfo[e.target.name]
                                : e.target.value,
                          },
                        });
                      }}
                      className={clases.formD}
                      name="path"
                      label="Path"
                      value={path}
                      required
                      fullWidth
                    />
                    <TextField
                      multiline
                      rows={3}
                      variant="outlined"
                      onChange={(e) => {
                        setcategoria({
                          ...categoria,
                          sidInfo: {
                            ...categoria.sidInfo,
                            [e.target.name]: e.target.value,
                          },
                        });
                      }}
                      className={clases.formAllW}
                      name="descripcion"
                      label="Descripción"
                      value={categoria.sidInfo.descripcion}
                      required
                      fullWidth
                    />
                    <Box mt={2} width="100%">
                      {/*  eslint-disable-next-line  */}
                      <a href="https://fonts.google.com/icons" target="_blank">
                        Ver Iconos
                      </a>
                    </Box>
                  </>
                ) : null}{" "}
                {inicioSeccion ? (
                  <>
                    {" "}
                    <TextField
                      onChange={(e) => {
                        setcategoria({
                          ...categoria,
                          sidInfo: {
                            ...categoria.sidInfo,
                            [e.target.name]: e.target.value,
                          },
                        });
                      }}
                      className={clases.formD}
                      name="mostrar"
                      label="Mostrar"
                      value={categoria.sidInfo.mostrar}
                      required
                      fullWidth
                      select
                      InputLabelProps={{ shrink: true }}
                      SelectProps={{ displayEmpty: true }}
                    >
                      {["SI", "NO"].map((item, index) => {
                        return (
                          <MenuItem key={index} value={item}>
                            {item}{" "}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <TextField
                      multiline
                      rows={3}
                      variant="outlined"
                      onChange={(e) => {
                        setcategoria({
                          ...categoria,
                          sidInfo: {
                            ...categoria.sidInfo,
                            [e.target.name]: e.target.value,
                          },
                        });
                      }}
                      className={clases.formAllW}
                      name="descripcion"
                      label="Descripción"
                      value={categoria.sidInfo.descripcion}
                      required
                      fullWidth
                    />
                  </>
                ) : null}
                {tutorialesSeccion ? (
                  <>
                    <>
                      <FormControl className={clases.formAllW}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent={"space-between"}
                        >
                          <Typography variant="subtitle1" color={"primary"}>
                            Tutorial:
                            <IconButton
                              aria-label=""
                              size="small"
                              onClick={async () => {
                                // const existeVacio = item.tutoriales.some(
                                //   (item) => {
                                //     if (item.tipo === "REFERENCIA") {
                                //       return (
                                //         item.tipo === "" ||
                                //         item.nombre === "" ||
                                //         item.telefono === ""
                                //       );
                                //     } else if (item.tipo === "INSTRUCCION") {
                                //       return (
                                //         item.tipo === "" ||
                                //         item.nombre === "" ||
                                //         item.nombreInstitucion === "" ||
                                //         item.desde === "" ||
                                //         item.hasta === ""
                                //       );
                                //     } else if (item.tipo === "EXPERIENCIA") {
                                //       return (
                                //         item.tipo === "" ||
                                //         item.nombre === "" ||
                                //         item.desde === "" ||
                                //         item.hasta === ""
                                //       );
                                //     } else {
                                //       return item.tipo === "";
                                //     }
                                //   }
                                // );

                                // if (existeVacio) {
                                //   return mostrarAlerta(
                                //     "Complete todos los campos.",
                                //     "error"
                                //   );
                                // }
                                setcategoria({
                                  ...categoria,
                                  sidInfo: {
                                    ...categoria.sidInfo,
                                    tutoriales: [
                                      ...tutoriales,
                                      {
                                        nombreVideo: "",
                                        urlVideo: "",
                                        descVideo: "",
                                      },
                                    ],
                                  },
                                });
                              }}
                            >
                              <AddCircle fontSize="small" color="secondary" />
                            </IconButton>
                          </Typography>
                        </Box>
                      </FormControl>

                      {tutoriales
                        .sort((a, b) => a.orden - b.orden)
                        .map((dato, index) => {
                          return (
                            <>
                              <Box
                                display={"flex"}
                                justifyContent="space-between"
                                className={clases.formAllW}
                                key={index}
                              >
                                <Typography
                                  key={index}
                                  variant="button"
                                  color="primary"
                                  fontWeight={"700"}
                                >
                                  {`Tutorial #${index + 1}`}
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setcategoria({
                                        ...categoria,
                                        sidInfo: {
                                          ...categoria.sidInfo,
                                          tutoriales: tutoriales.filter(
                                            (item, indexItem) => {
                                              return indexItem !== index;
                                            }
                                          ),
                                        },
                                      });
                                    }}
                                  >
                                    <Delete color="error" fontSize="small" />
                                  </IconButton>
                                </Typography>
                              </Box>
                              {/* DATO */}
                              <TextField
                                className={clases.form33}
                                size="small"
                                label="Nombre"
                                value={dato.nombreVideo}
                                onChange={(e) => {
                                  setcategoria({
                                    ...categoria,
                                    sidInfo: {
                                      ...categoria.sidInfo,
                                      tutoriales: tutoriales.map(
                                        (item, indexItem) => {
                                          if (indexItem === index) {
                                            return {
                                              ...item,
                                              nombreVideo: e.target.value,
                                            };
                                          } else {
                                            return item;
                                          }
                                        }
                                      ),
                                    },
                                  });
                                }}
                              />{" "}
                              <TextField
                                className={clases.form33}
                                size="small"
                                label="Descripción"
                                value={dato.descVideo}
                                onChange={(e) => {
                                  setcategoria({
                                    ...categoria,
                                    sidInfo: {
                                      ...categoria.sidInfo,
                                      tutoriales: tutoriales.map(
                                        (item, indexItem) => {
                                          if (indexItem === index) {
                                            return {
                                              ...item,
                                              descVideo: e.target.value,
                                            };
                                          } else {
                                            return item;
                                          }
                                        }
                                      ),
                                    },
                                  });
                                }}
                              />
                              <TextField
                                className={clases.form33}
                                size="small"
                                label="URL"
                                value={dato.urlVideo}
                                onChange={(e) => {
                                  setcategoria({
                                    ...categoria,
                                    sidInfo: {
                                      ...categoria.sidInfo,
                                      tutoriales: tutoriales.map(
                                        (item, indexItem) => {
                                          if (indexItem === index) {
                                            return {
                                              ...item,
                                              urlVideo: e.target.value,
                                            };
                                          } else {
                                            return item;
                                          }
                                        }
                                      ),
                                    },
                                  });
                                }}
                              />{" "}
                              {/* DELETE */}
                            </>
                          );
                        })}
                    </>
                  </>
                ) : null}
              </Box>
              {/* <Divider /> */}

              <Box
                display="flex"
                width="100%"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="flex-end"
                  mt={1}
                >
                  <Button
                    style={{ width: "30%" }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handleEditar();
                    }}
                  >
                    Guardar
                  </Button>
                </Box>
              </Box>
            </div>
          </Box>
        </Draggable>
      </Box>
    </Modal>
  );
};

export default memo(ModalAsignatura);
